import React from 'react';
import styled, { useTheme } from 'styled-components';
import { Typography } from 'ui-kit/Typography';
import Trash from "assets/trash.svg";
import Edit from "assets/edit.svg";

interface ContributorItemProps {
  label: string;
  description: string;
  onRemove: () => void;
  setIsOpenContributorsModal:(openContributorsModal:boolean)=>void
}

export const ContributorItem: React.FC<ContributorItemProps> = props => {
  const theme = useTheme();
  return (
    <Container>
      <Top>
        <Typography variant="body6" color={theme.palette.text.link}>{props.label}</Typography>
        <div style={{  cursor: 'pointer' }}>
        
          <TrashContainer onClick={props.onRemove}>
            <Trash />
          </TrashContainer>
        </div>
      </Top>
      <Bottom>{props.description}</Bottom>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  border: 1px solid #A4A4A4;
  border-radius: 7px;
  padding: 4px 6px 10px 9px;
  width: 160px;
  min-height: 68px;
`;

const Top = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 5px;
`;

const Bottom = styled.div`
  font-weight: 400;
  font-size: 13px;
  line-height: 15px;
`;

const TrashContainer = styled.div`
  cursor: pointer;
`;
